export enum LocalStorageKey {
  DEFAULT_ASSET_IDS = "default-asset-ids",
}
